"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStepStatus = exports.useStepperState = void 0;
var react_1 = require("react");
function useStepperState(initialCurrStep) {
    if (initialCurrStep === void 0) { initialCurrStep = 0; }
    var _a = react_1.useState(initialCurrStep), currentStep = _a[0], setCurrentStep = _a[1];
    var nextStep = function () { return setCurrentStep(function (step) { return step + 1; }); };
    var previousStep = function () { return setCurrentStep(function (step) { return step - 1; }); };
    return {
        getStepStatus: function (step) { return getStepStatus(step, currentStep); },
        currentStep: currentStep,
        setCurrentStep: setCurrentStep,
        nextStep: nextStep,
        previousStep: previousStep,
    };
}
exports.useStepperState = useStepperState;
/**
 * Create a StepProps properties object to pass to a Step component, based on its index and current Stepper state.
 *
 * @param step The step index that will receive the props.
 * @param currentActiveStep The current active stepper step.
 */
function getStepStatus(step, currentActiveStep) {
    return (step < currentActiveStep && 'completed') || (step > currentActiveStep && 'incompleted') || 'active';
}
exports.getStepStatus = getStepStatus;
//# sourceMappingURL=useStepperState.js.map